import { Component, computed, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { FullReservation } from '../../../core/models/reservation/full-reservation';

@Component({
  selector: 'app-reservation-list',
  imports: [TegelModule],
  templateUrl: './reservation-list.component.html',
  styleUrl: './reservation-list.component.scss'
})
export class ReservationListComponent implements OnInit, OnChanges {

  
  @Input() data: FullReservation[] = [];

  filteredData = signal<FullReservation[]>([]);
  page = signal<number>(1);
  rowsPerPage = signal<number>(10);
  
  /** Reactive state and computed properties for managing table data, pagination, and sorting */
  tableData = computed(() => {
    const startIndex = (this.page() - 1) * this.rowsPerPage();
    const endIndex = startIndex + this.rowsPerPage();
    return this.filteredData().slice(startIndex, endIndex);
  });
  
  pages = computed(() => 
    Math.ceil(this.filteredData().length / this.rowsPerPage())
  );

  rowsPerPageValuesArray = [10, 20];
  currentSortKey: string = '';
  currentSortDirection: 'asc' | 'desc' = 'asc';
  currentFilter: string = '';

  ngOnInit() {

    this.initializeFilteredData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && changes['data'].currentValue) {
      this.initializeFilteredData();
    }
  }

  private initializeFilteredData() {
    if (this.data) {
      /** Ensures data is always an array */
      const dataArray = Array.isArray(this.data) ? this.data : [this.data];
      /** Filter data when user is not null */
      const filteredArray = dataArray.filter(item => item.username != null);
      this.filteredData.set([...filteredArray]);
    }
  }

  /** Handles filtering of reservation data based on the user's search query. */
  handleFilter(event: any) {
    const { query } = event.detail;
    this.currentFilter = query;
    
    let filtered: FullReservation[] = [];
    if (this.data) {
      filtered = (Array.isArray(this.data) ? this.data : [this.data])
        .filter((object: FullReservation) => object.username != null) // Filtrar username null
        .filter((object: FullReservation) =>
          Object.values(object).some((value) =>
            value != null && value.toString().toLowerCase().includes(query.toLowerCase())
          )
        );
    }
    
    if (this.currentSortKey) {
      filtered = this.applySortingToArray(filtered);
    }
    
    this.filteredData.set(filtered);
    this.page.set(1);
  }

  /** handles pagination chenges by triggering a pagination event */
  handlePagination(event: any) {
    const { paginationValue, rowsPerPage } = event.detail;
    this.page.set(paginationValue);
    this.rowsPerPage.set(rowsPerPage);
  }
 /** Handles sorting of the data table based on the selected column and direction */
  sort(event: any) {
    const key = event.detail.columnKey;
    const direction = event.detail.sortingDirection;
    
    this.currentSortKey = key;
    this.currentSortDirection = direction;
    
    const sorted = this.applySortingToArray([...this.filteredData()]);
    this.filteredData.set(sorted);
    this.page.set(1);
  }

  /** Applies sorting to an array of data based on the current sort key */
  private applySortingToArray(array: any[]) {
    if (!this.currentSortKey) return array;
    
    return array.sort((a, b) => {
      let comparison = 0;
      const aVal = a[this.currentSortKey] ?? '';
      const bVal = b[this.currentSortKey] ?? '';
      
      if (aVal < bVal) comparison = -1;
      if (aVal > bVal) comparison = 1;
      
      return this.currentSortDirection === 'desc' ? comparison * -1 : comparison;
    });
  }

}
